// PEME pipeline stage overview - 6 cards showing crew count per stage
import React from 'react';
import { cn } from 'lib/utils';
import { STAGE_CONFIG } from '../../constants/peme-stages';
import './pipeline-overview-cards.scss';

const DEFAULT_ICON_THEME = { bg: 'tw-bg-indigo-50', color: 'tw-text-indigo-500' };

const SkeletonCard = () => (
  <div className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-xl tw-px-5 tw-py-4 tw-animate-pulse">
    <div className="tw-flex tw-items-start tw-justify-between">
      <div className="tw-flex tw-flex-col tw-gap-2">
        <div className="tw-h-3 tw-w-28 tw-bg-slate-200 tw-rounded" />
        <div className="tw-h-7 tw-w-10 tw-bg-slate-200 tw-rounded" />
        <div className="tw-h-3 tw-w-16 tw-bg-slate-200 tw-rounded" />
      </div>
      <div className="tw-w-9 tw-h-9 tw-rounded-lg tw-bg-slate-200 tw-flex-shrink-0" />
    </div>
  </div>
);

const StageCard = ({ stage }) => {
  const config = STAGE_CONFIG[stage.name] || {};
  const IconComponent = config.icon;
  const theme = { bg: config.bg || DEFAULT_ICON_THEME.bg, color: config.color || DEFAULT_ICON_THEME.color };

  return (
    <div className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-xl tw-px-5 tw-py-4">
      <div className="tw-flex tw-items-start tw-justify-between">
        {/* Left: text */}
        <div className="tw-flex tw-flex-col">
          <span className="tw-text-xs tw-text-gray-500 tw-font-medium tw-leading-tight">
            {stage.name}
          </span>
          <span className="tw-text-2xl tw-font-bold tw-text-gray-900 tw-mt-1 tw-leading-none">
            {stage.count}
          </span>
          <span className="tw-text-xs tw-text-gray-400 tw-mt-1">
            {stage.status}
          </span>
        </div>

        {/* Right: icon */}
        <div
          className={cn(
            'tw-w-9 tw-h-9 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-flex-shrink-0',
            theme.bg
          )}
          aria-hidden="true"
        >
          {IconComponent && <IconComponent className={cn('tw-w-4 tw-h-4', theme.color)} />}
        </div>
      </div>
    </div>
  );
};

const PipelineOverviewCards = ({ stages = [], isLoading }) => {
  if (isLoading) {
    return (
      <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-6 tw-gap-3 tw-mt-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-6 tw-gap-3 tw-mt-4">
      {stages.map((stage) => (
        <StageCard key={stage.name} stage={stage} />
      ))}
    </div>
  );
};

export default PipelineOverviewCards;
